<template>
  <div class="flex flex-col gap-y-8">
    <!-- 新動線の S2。見出しはアコーディオン側が出し、総額は畳むと見えなくなるので下部固定バーへ移している（D-014）ため、旧動線の OptionSection から両方を除いた形 -->
    <ReservationOptionFields
      :experience-event="props.experienceEvent"
      :get-error-message="props.getErrorMessage"
      :on-click-image="props.onClickImage"
      :slug="props.slug"
      :thumbnail-image-url="props.thumbnailImageUrl"
      hides-single-interpreter-choice
    />
  </div>
</template>

<script setup lang="ts">
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';
import ReservationOptionFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/ReservationOptionFields/ReservationOptionFields.vue';

interface Props {
  getErrorMessage: (s: string) => string;
  thumbnailImageUrl?: string;
  slug: string;
  experienceEvent: WabunkaExperienceEventViewModel;
  onClickImage: () => void;
}
const props = defineProps<Props>();
</script>
